import './Shell.css';
import { Route, Routes } from 'react-router-dom';
import ShareList from '../features/shares/ShareList';
import { AuthenticatedTemplate, MsalAuthenticationTemplate, useAccount, useMsal } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { Segment } from 'semantic-ui-react';
import FinishedScreen from '../features/shares/FinishedScreen';

/**
 * Core UI component for the webapp.
 */
const Shell = () => {

	const { instance, accounts } = useMsal();
	const account = useAccount(accounts[0] || {});

	// Get SSO. And hope.
	const sso = account?.idTokenClaims?.preferred_username?.substring(0, account?.idTokenClaims?.preferred_username?.indexOf('@'));

	return <>
		<MsalAuthenticationTemplate interactionType={InteractionType.Redirect} >
		</MsalAuthenticationTemplate>
		<AuthenticatedTemplate>
		{
			sso === undefined
			?
			<Segment>
				Valid authentication token was not found. Please refresh the page and log in.
			</Segment>
			:
			<Routes>
				{/*
				<Route path='/' element={<ShareList sso={sso} instance={instance} account={account} />} />
				*/}
				<Route path='/' element={<FinishedScreen sso={sso} instance={instance} account={account} />} />
			</Routes>
		}
		</AuthenticatedTemplate>
	</>
}

export default Shell;
